import { render, staticRenderFns } from "./InvoiceReceipt.vue?vue&type=template&id=a66d2f54&scoped=true&"
import script from "./InvoiceReceipt.vue?vue&type=script&lang=js&"
export * from "./InvoiceReceipt.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceReceipt.vue?vue&type=style&index=0&id=a66d2f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66d2f54",
  null
  
)

export default component.exports